<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-icon color="info" v-on="on">{{ icon }}</v-icon>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
import { TR } from "../../main";

export default {
  props: {
    icon: {
      type: String,
      default: "mdi-caps-lock",
    },
    tooltipText: {
      type: String,
      default: () => TR.CapsTooltip_CapsON,
    },
  },
};
</script>

<style scoped>
</style>